import { register } from "register-service-worker";

if ("serviceWorker" in navigator) {
	register(`${process.env.BASE_URL}service-worker.js`, {
		ready() {
			console.log(
				"App is being served from cache by a service worker. For more details, visit https://goo.gl/AFskqB"
			);
		},
		registered(registration) {
			setInterval(() => {
				registration.update();
			}, 10000); // 1 hour check = 1000 * 60 * 60
			console.log("Service worker has been registered.");
		},
		cached() {
			console.log("Content has been cached for offline use.");
		},
		updatefound() {
			console.log("New content is downloading.");
		},
		updated(registration) {
			console.log("New content is available; please refresh.");
			document.dispatchEvent(
				new CustomEvent("swUpdated", { detail: registration })
			);
		},
		offline() {
			console.log(
				"No internet connection found. App is running in offline mode."
			);
		},
		error(error) {
			console.error("Error during service worker registration:", error);
		},
	});
}
